import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {PropertiesDictionaryDialogComponent} from './properties-dictionary-dialog/properties-dictionary-dialog.component';
import * as _ from 'lodash';
import {AttributesApiService} from '../../services/api/users/attributes/attributes-api.service';
import {ConfirmationDialogComponent} from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {SnackBarService} from '../../services/common/snack-bar/snack-bar.service';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {TrueFalsePipe} from '../../pipes/true-false/true-false.pipe';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import {RoleTypeEnum} from '../../services/enums/role-type.enum';


@Component({
    selector: 'properties-dictionary',
    templateUrl: './properties-dictionary.component.html',
    styleUrls: ['./properties-dictionary.component.scss']
})
export class PropertiesDictionaryComponent implements OnInit {
    selectedItem;
    isUnauthorized: boolean;
    items = [];
    search = '';
    filter;

    @ViewChild(ArmTableComponent) armTable;

    displayedColumns: Array<DisplayedColumnInf> = [
        { name: 'name', display: 'Name', selected: true, width: 200 },
        { name: 'description', display: 'Description', selected: true, width: 200 },
        { name: 'dialable', display: 'Dialable', selected: true, width: 200, transformer: TrueFalsePipe },
        { name: 'primary', display: 'Displayed in users table', selected: true, width: 200, transformer: TrueFalsePipe },
        { name: 'isCombined', display: 'Combined', selected: true, width: 200, transformer: TrueFalsePipe }
    ];

    constructor(private attributesApiService: AttributesApiService,
                private snackBarService: SnackBarService,
                private userPrivilege: UserPrivilegeService,
                public dialog: MatDialog,private loaderService: LoaderService) {
    }

    ngOnInit(): void {
        this.isUnauthorized = !this.userPrivilege.isAuthorized(RoleTypeEnum.USER_MANAGEMENT);

        this.refresh();
    }

    addItem(): void {
        const dialogRef = this.dialog.open(PropertiesDictionaryDialogComponent, {
            width: '460px',
            data: {
                isEditMode: false,
                attributes: this.items
            }
        });

        dialogRef.componentInstance.onApply.subscribe(result => {
            this.attributesApiService.addAttribute(result).then(() => {
                dialogRef.close();
                this.snackBarService.display(`"${result.name}" successfully added`);
                this.refresh();
            });
        });
    }

    editItem(): void {
        const dialogRef = this.dialog.open(PropertiesDictionaryDialogComponent, {
            width: '460px',
            data: {
                isEditMode: true,
                attributes: this.items,
                selectedItem: _.cloneDeep(this.selectedItem)
            }
        });

        dialogRef.componentInstance.onApply.subscribe(result => {
            this.attributesApiService.editAttribute(result).then(() => {
                dialogRef.close();
                this.snackBarService.display(`"${result.name}" successfully edited`);
                this.refresh();
            });
        });
    }

    removeItem(): void {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '460px',
            data: {
                message: `Are you sure you want to delete "${this.selectedItem.name}" ?`
            }
        });

        dialogRef.componentInstance.onApply.subscribe(result => {
              this.attributesApiService.deleteAttribute(this.selectedItem).then(() => {
                  dialogRef.close();
                  this.refresh();
                  this.snackBarService.display(`${this.selectedItem.name} successfully deleted`);
              });
        });
    }

    refresh(): void {
      this.loaderService.showMainContainer();
        this.attributesApiService.getAttributes()
            .then(items => {
                this.items = items;
              this.loaderService.hideMainContainer();
            }).catch(err => {
          console.log(`Exception was thrown in refresh property dictionary, reason: ${err}`);
          this.loaderService.hideMainContainer();
        });
    }

    isActionDisabled(): boolean {
        return !this.selectedItem || this.isUnauthorized;
    }

    select(item: any): void {
        this.selectedItem = item;
    }

    onFilter(filter: any): any {
      this.armTable.firstPage();
      this.filter = filter;
    }
}
